export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade AES-256 encryption protects your data from hackers and surveillance.'
    },
    {
      icon: 'ri-speed-line',
      title: 'Lightning Fast',
      description: 'Optimized servers worldwide ensure blazing-fast speeds without compromising security.'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Access',
      description: 'Connect to servers in multiple countries and access content from anywhere in the world.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero Logs Policy',
      description: 'We never track, collect, or share your private data. Your privacy is guaranteed.'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">
            Why Choose Our VPN
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Experience the perfect combination of security, speed, and privacy with our cutting-edge VPN technology
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
